<template>
  <div id="appcompetences--widget" class="widget toolbox paragraphe--0 clearfix">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  props: ['configuration', 'globals'],
};
</script>

<style>
#appcompetences--widget {
  padding: 1rem 2rem 0;
  border: 1px solid lightgrey;
  position: relative;
}

#appcompetences--widget .wrapper__content {
  padding-bottom: 1rem;
  position: relative;
}

#appcompetences--widget .start-button {
  display: block;
  text-align: center;
  cursor: pointer;
}

#appcompetences--widget .appcompetences_footer .appcompetences_footer_precedent,
#appcompetences--widget .button-back {
  padding: 1rem 2.5rem;
  font-size: 1.2rem;
  margin: 1rem;
  color: #002e5d;
}

#appcompetences--widget .appcompetences_footer .appcompetences_footer_precedent,
#appcompetences--widget .appcompetences_footer .appcompetences_footer_suivant {
  margin: .5em;
  font-size: 1em;
}

#appcompetences--widget .appcompetences_footer .appcompetences_footer_precedent {
  padding: 0 2.5rem;
}

@media (min-width: 932px) {
  #appcompetences--widget .appcompetences_footer .appcompetences_footer_precedent {
    padding: 1rem 2.5rem;
  }
}

#appcompetences--widget .button-app {
  background-color: #002e5d;
  color: #fff;
  font-family: "euclid_flex";
  padding: 1rem 2.5rem;
  font-size: 1.2rem;

}

#appcompetences--widget .container-flex-select {
  display: flex;
  flex-wrap: wrap;
}

#appcompetences--widget .container-flex-select p {
  width: 100%;
  margin-top: 1.5rem;
}

#appcompetences--widget button.button-primary,
#appcompetences--widget .appcompetences_footer button {
  font-family: "euclid_flex";
  font-weight: bold;
  padding: 1rem 2.5rem;
  font-size: 1.2rem;
  border: none;
}

#appcompetences--widget .big-button.big-button {
  width: 100%;
  margin: 1% 0;
  border: 1px solid lightgrey;
  font-weight: 400;
  text-transform: none;
  font-size: 1.2rem;
  border-radius: .4rem;
  padding: 1.5rem;
  background-color: #fff;
  color: #515961;
  cursor: pointer;
}

@media (min-width: 932px) {
  #appcompetences--widget .big-button.big-button {
    width: 30%;
    margin: 1.66%;
    padding: 1.5rem 1rem;
  }
}

#appcompetences--widget .big-button.big-button:active,
#appcompetences--widget .big-button.big-button.actif {
  box-shadow: none !important;
  background-color: #515961;
  color: #fff;
}

#appcompetences--widget .start-button {
  margin: 1% auto;
}

#appcompetences--widget label {
  color: #515961;
  margin: 1rem 0;
  font-weight: 400;
}

#appcompetences--widget input:after {
  background-color: #fff;
}

#appcompetences--widget .repeaterniveau.repeaterniveau.repeaterniveau.repeaterniveau {
  border: solid 1px darkgrey;
  width: 8px !important;
  height: 8px;
  margin-right: 1px;
  box-sizing: inherit; /* surcharge toolbox */
  vertical-align: middle; /* surcharge toolbox */
  padding-left: inherit; /* surcharge toolbox */
}

#appcompetences--widget .app-element-center {
  display: flex;
  flex-direction: column;
  align-items: center;
}

#appcompetences--widget ul > li ul {
  margin-bottom: 1.5em;
}

#appcompetences--widget ul > li ul > li {
  position: relative;
  padding-left: 16px;
}

#appcompetences--widget button {
  text-transform: uppercase;
}

#appcompetences--widget ul > li ul > li::before {
  color: #515961;
  content: '\2022';
  font-family: "euclid_flex", Arial, "Helvetica Neue", Helvetica, "Bitstream Vera Sans", sans-serif;
  font-size: 87.5%;
  line-height: 1;
  margin-right: 0.5rem;
  position: absolute;
  top: 0.5625em;
}

#appcompetences--widget h2,
#appcompetences--widget .h2 {
  position: relative;
  margin: 1.5rem 0 2rem;
}

#appcompetences--widget .big-button:focus {
  outline: none;
}

#appcompetences--widget .checkbox-wrapper {
  display: flex;
  align-items: flex-start;
}

#appcompetences--widget .checkbox-wrapper label {
  margin-top: 0;
}
</style>
